import { render } from "./index.vue?vue&type=template&id=596b7afd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=596b7afd&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596b7afd"],['__file',"src/components/upLoadVideo/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "596b7afd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('596b7afd', __exports__)) {
    console.log('reload')
    api.reload('596b7afd', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=596b7afd&scoped=true", () => {
    console.log('re-render')
    api.rerender('596b7afd', render)
  })

}


export default __exports__